import Layout from '@/layout'

export default {
	path: '/attendance',
	component: Layout,
	name: '考勤系统',
	id: 1400000,
	meta: {
		title: '考勤',
		roles: [1400000]
	},
	redirect: 'noRedirect',
	children: [

		{
			path: 'flight',
			component: () =>
				import(/* webpackChunkName: "flight" */ '@/leniuview/attendance/flight.vue'),
			name: '班次管理',
			id: 1400200,
			meta: { title: '班次管理', roles: [1400200] }
		},
		{
			path: 'workforce',
			component: () =>
				import(/* webpackChunkName: "workforce" */ '@/leniuview/attendance/workforce.vue'),
			name: '排班管理',
			id: 1400300,
			meta: { title: '排班管理', noCache: true, roles: [1400300] }
		},
		{
			path: 'vacateType',
			component: () =>
				import(/* webpackChunkName: "vacateType" */ '@/leniuview/attendance/vacateType.vue'),
			name: '请假类型',
			id: 1400400,
			meta: { title: '请假类型', roles: [1400400] }
		},
		{
			path: 'vacate',
			component: () =>
				import(/* webpackChunkName: "vacate" */ '@/leniuview/attendance/vacate.vue'),
			name: '请假管理',
			id: 1400500,
			meta: { title: '请假管理', roles: [1400500] }
		},
		{
			path: 'overTime',
			component: () =>
				import(/* webpackChunkName: "overTime" */ '@/leniuview/attendance/overTime.vue'),
			name: '加班管理',
			id: 1400600,
			meta: { title: '加班管理', roles: [1400600] }
		},
		{
			path: 'punch-records',
			component: () =>
				import(/* webpackChunkName: "punch-records" */ '@/leniuview/attendance/punch-records.vue'),
			name: '打卡记录',
			id: 1401000,
			meta: { title: '打卡记录', roles: [1401000] }
		},
		{
			path: 'attendance-records',
			component: () =>
				import(/* webpackChunkName: "attendance-records" */ '@/leniuview/attendance/attendance-records.vue'),
			name: '考勤记录',
			id: 1400100,
			meta: { title: '考勤记录', roles: [1400100] }
		},
		{
			path: 'attendance-detail',
			component: () =>
				import(/* webpackChunkName: "attendance-detail" */ '@/leniuview/attendance/attendance-detail.vue'),
			name: '考勤明细',
			id: 1400700,
			meta: { title: '考勤明细', roles: [1400700] }
		},
		{
			path: 'attendance-summary',
			component: () =>
				import(/* webpackChunkName: "attendance-summary" */ '@/leniuview/attendance/attendance-summary.vue'),
			name: '考勤汇总',
			id: 1400800,
			meta: { title: '考勤汇总', roles: [1400800] }
		},
		{
			path: 'attendance-machine',
			component: () =>
				import(/* webpackChunkName: "attendance-machine" */ '@/leniuview/attendance/attendance-machine.vue'),
			name: '设备管理',
			id: 1400900,
			meta: { title: '设备管理', roles: [1400900] }
		}
	]
}
